import { Module, Action, getModule } from 'vuex-module-decorators';

import { getById, addNewEntity, updateEntity } from '@/api/crud';

import store from '@/store';
import EntityBaseModule from '@/store/entity';

import EntityModel from './entityModel';

import { Patients } from '@/models/patients';
import { PatientModel, PatientProfile } from '@/types/models/patients';

import { transformBackendProfile, transformProfile } from './backend';
import { activatePatient, deactivatePatient } from '@/api/patients';

// TODO: move to common type helpers
type UpdateData<Data, Id = string> = {
    id: Id,
    data: Data,
}

export const MODULE_NAME = Patients.moduleEntityName;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class PatientEntityModule extends EntityBaseModule {
    model: PatientModel;

    constructor(module: PatientEntityModule) {
        super(module);

        const entityModel = new EntityModel();
        this.model = entityModel.model;
    }

    @Action({ rawError: true })
    async getById(id: string) {
        try {
            const result = await getById(Patients.moduleName, id);

            return transformBackendProfile(result.patient);
        } catch (clientError: any) {
            const error = clientError.response.data;

            throw new Error(error.message);
        }
    }

    @Action({ rawError: true })
    async createNew(data: PatientProfile) {
        const profile = transformProfile(data);

        try {
            const { result } = await addNewEntity(Patients.moduleName, profile);
    
            return result.id;
        } catch (clientError: any) {
            const error = clientError.response.data;
            const errors = error.errors?.fields ?? {}

            throw errors;
        }

    }

    @Action({ rawError: true })
    async update({ id, data }: UpdateData<PatientProfile>) {
        const profile = transformProfile(data);

        try {
            await updateEntity(Patients.moduleName, id, profile);
        } catch (clientError: any) {
            const error = clientError.response.data;
            const errors = error.errors.fields

            throw errors;
        }
    }

    @Action({ rawError: true })
    async activate(id: string) {
        try {
            await activatePatient(id);
        } catch (clientError: any) {
            const error = clientError.response.data;
            const errors = error.errors.fields

            throw errors;
        }
    }

    @Action({ rawError: true })
    async deactivate(id: string) {
        try {
            await deactivatePatient(id);
        } catch (clientError: any) {
            const error = clientError.response.data;
            const errors = error.errors.fields

            throw errors;
        }
    }
}

export default getModule(PatientEntityModule);
